"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReanimatedBottomSheet = exports.ReanimatedBottomSheetProvider = exports.RESET = exports.SET_SNAPPOINTS = exports.SET_SCROLLABLE_CONTENT_HEIGHT = exports.SET_SCROLL_Y_POSITION = void 0;
const bottom_sheet_1 = require("@gorhom/bottom-sheet");
const react_1 = __importStar(require("react"));
exports.SET_SCROLL_Y_POSITION = 'SET_SCROLL_Y_POSITION';
exports.SET_SCROLLABLE_CONTENT_HEIGHT = 'SET_SCROLLABLE_CONTENT_HEIGHT';
exports.SET_SNAPPOINTS = 'SET_SNAPPOINTS';
exports.RESET = 'RESET';
const initialState = {
    scrollY: 0,
    snapPoints: [],
    scrollableContentHeight: 0,
};
const stateReducer = (state, action) => {
    switch (action.type) {
        case exports.SET_SCROLL_Y_POSITION: {
            return {
                ...state,
                scrollY: action.scrollY,
            };
        }
        case exports.SET_SCROLLABLE_CONTENT_HEIGHT: {
            return {
                ...state,
                scrollableContentHeight: action.scrollableContentHeight,
            };
        }
        case exports.SET_SNAPPOINTS: {
            return {
                ...state,
                snapPoints: action.snapPoints,
            };
        }
        case exports.RESET:
            return {
                ...initialState,
            };
        default: {
            throw new Error('ReanimatedBottomSheetContext: Unhandled action type!');
        }
    }
};
const ReanimatedBottomSheetContext = react_1.default.createContext(undefined);
exports.ReanimatedBottomSheetProvider = ({ children, }) => {
    const [state, dispatch] = react_1.useReducer(stateReducer, initialState);
    const value = { state, dispatch };
    return (react_1.default.createElement(ReanimatedBottomSheetContext.Provider, { value: value },
        react_1.default.createElement(bottom_sheet_1.BottomSheetModalProvider, null, children)));
};
exports.useReanimatedBottomSheet = () => {
    const context = react_1.default.useContext(ReanimatedBottomSheetContext);
    if (context === undefined) {
        throw new Error('useReanimatedBottomSheet must be used within ReanimatedBottomSheetProvider');
    }
    return context;
};
